/**
 * @version 1.0
 * @author Kelnik Studios {http://kelnik.ru}
 * @link https://kelnik.gitbooks.io/kelnik-documentation/content/front-end/components/menu-trigger.html documentation
 */

import Observer from 'common/scripts/observer';

const observer = new Observer();

class ButtonTrigger {
    constructor() {
        /**
         * Элемент по которому кликают
         * @type {null}
         */
        this.button = null;

        /**
         * тип элемента, например меню, поиск. Нужно для публикации через медиатор в свиче
         * @type {string}
         */
        this.type = ``;

        /**
         * css-класс для состояния открытия
         * @type {string}
         */
        this.classStateOpen = `is-open`;

        /**
         * css-класс для состояния закрытия
         * @type {string}
         */
        this.classStateClose = `is-close`;

        /**
         * Класс скрытой кнопки
         * @type {string}
         */
        this.classHide = `is-hide`;

        /**
         * Состояния кнопки
         * open - открывает
         * close - закрывает
         * @type {string}
         */
        this.state = null;

        /**
         * Динамичность кнопки
         * Если динамичная, то состояние меняется при клике
         * если не динамичное, то состояние вообще не меняется
         * @type {boolean}
         */
        this.dynamic = true;

        /**
         * строка со значением события для медиатора для состояния открытия
         * @type {string}
         */
        this.eventClose = ``;

        /**
         * строка со значением события для медиатора для состояния закрытия
         * @type {string}
         */
        this.eventOpen = ``;
    }

    /**
     * Инициализирует компонент
     * @param {Object} options - объект настроек
     */
    init(options) {
        this.button = options.target;
        this.eventClose = options.eventClose;
        this.eventOpen = options.eventOpen;
        this.state = this.button.classList.contains(this.classStateOpen) ? 'open' : 'close';
        this.dynamic = this.button.dataset.dynamic || true;

        this._bindEvents();
        this._subscribes();
    }

    /**
     * Навешивает слушателей на элементы
     * @private
     */
    _bindEvents() {
        this.button.addEventListener('click', this._clickBind.bind(this));
    }

    /**
     * Метод содержит в себе колбэки на события других модулей.
     * @private
     */
    _subscribes() {
        observer.subscribe('scrollbyStart', () => {
            this.state = 'close';
            this.button.classList.add(this.classStateClose);
            this.button.classList.remove(this.classStateOpen);
        });
    }

    /**
     * Обрабатывает клик
     * @private
     */
    _clickBind() {
        if (this.dynamic) {
            this._toggleClass();
            this._changeState();
        } else {
            this._changeState();
        }
    }

    /**
     * Изменяет состояние
     * с отрытого на закрытое и наоборот
     * @private
     */
    _changeState() {
        if (this.state === 'open') {
            this._stateClose();
            this.state = 'close';
        } else {
            this.state = 'open';
            this._stateOpen();
        }
    }

    /**
     * Изменяет классы на элементе с открытого на закрытое и открытое
     * @private
     */
    _toggleClass() {
        this.button.classList.toggle(this.classStateClose);
        this.button.classList.toggle(this.classStateOpen);
    }

    /**
     * Сообщает, что компонент открыт
     * @private
     */
    _stateOpen() {
        observer.publish(this.eventOpen, this);
    }

    /**
     * Сообщает, что компонент закрыт
     * @private
     */
    _stateClose() {
        observer.publish(this.eventClose, this);
    }
}

export default ButtonTrigger;
